export function capitalizeFirstLetter(word) {
  if (!word) return undefined;
  return word.charAt(0).toUpperCase() + word.slice(1);
}

/// WIP to sanitize plaid categories into domain category IDs
export const sanitizeCategoryToId = (string) =>
  string.toUpperCase().replace(/[.,&]/g, '').replace(/\s+/g, '_').trim();
